import moment from "moment";
import lodash from "lodash";
import { mapGetters } from "vuex";
import { toast, updateGlobalOptions } from "vue3-toastify";

export default {
  watch: {
    user(value) {
      if (value) {
        updateGlobalOptions({
          theme: value?.settings?.theme == "light" ? "dark" : "light",
          hideProgressBar: true,
          position: "bottom-center"
        });
      }
    }
  },
  computed: {
    ...mapGetters({
      user: "auth/user"
    }),
    $_() {
      return lodash;
    },
    $toaster() {
      return toast;
    },
    is_admin() {
      return this?.user?.site == "ims" && this?.user?.role == "admin";
    },
    pan_card_regex() {
      return /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
    },
    gst_regex() {
      return /^[0-9]{2}[A-Za-z]{5}[0-9]{4}[A-Za-z][A-Za-z0-9]{3}$/;
    }
  },
  methods: {
    $moment(_date) {
      return _date ? moment(new Date(_date)) : moment();
    },

    renderDateShort(_date) {
      return _date != null && moment(new Date(_date)).isValid() ? moment(new Date(_date)).format("L") : "";
    },

    renderMonthName(_date) {
      return _date != null && moment(new Date(_date)).isValid() ? moment(new Date(_date)).format("MMMM") : "";
    },

    renderDateLong(_date) {
      return _date != null && moment(new Date(_date)).isValid() ? moment(new Date(_date)).format("ll") : "";
    },

    renderDateLongTime(_date) {
      return _date != null && moment(new Date(_date)).isValid() ? moment(new Date(_date)).format("ll LT") : "";
    },

    renderDateLongTimeSeconds(_date) {
      return _date != null && moment(new Date(_date)).isValid() ? moment(new Date(_date)).format("ll LTS") : "";
    },

    renderTime(_date) {
      return _date != null && moment(new Date(_date)).isValid() ? moment(new Date(_date)).format("LT") : "";
    }
  }
};
